
var AnswerModel = function (obj) {
    if (obj) {
        //回复
        this.answer = obj.answer;
    } else {
        //回复
        this.answer  = "";
    }
};

AnswerModel.prototype = {
    toString: function () {
        var result = `<answer>{0}</answer>>`;
        result = result.format(this.answer);
        return result;
    }
};
export default AnswerModel;